'use client';

import { useEffect, useRef } from 'react';

import { useAuth } from '@flipster/features/src/shared/auth/state';
import { languageTagToSupportedLocale } from '@flipster/i18n/constants';
import { useSupportedLocale } from '@flipster/i18n/hooks';
import { usePathname } from '@flipster/i18n/routing';
import { LanguageTag } from '@flipster/i18n/types';

/**
 * 유저가 설정한 언어와 다른 언어로 접근하려고 하면 리다이렉트
 */
export const UserLanguageRedirect = () => {
  const { user } = useAuth();
  const currentLocale = useSupportedLocale();
  const pathname = usePathname();
  const hasRedirectedRef = useRef(false);

  useEffect(() => {
    // 이미 리다이렉트했거나 언어설정 확인이 되지 않으면 실행하지 않음
    if (hasRedirectedRef.current || !user?.lang) return;

    const userLanguage = user.lang as LanguageTag;
    const preferredLocale = languageTagToSupportedLocale[userLanguage];
    // 현재 locale과 사용자 선호 locale이 다르면 리다이렉트
    if (preferredLocale !== currentLocale) {
      window.location.replace(`/${preferredLocale}${pathname}`);
      hasRedirectedRef.current = true;
    }
  }, [user, currentLocale, pathname]);

  return null;
};
